import {
	Box,
	Button,
	Checkbox,
	Divider,
	Grid,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
	tableCellClasses,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useEffect, useState, useRef, useMemo } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useOutletContext } from 'react-router-dom';
import CheckIcon from '@mui/icons-material/Check';
import darkBarcode from '../../assets/images/darkbarcode.png';
import lightBarcode from '../../assets/images/Bar_code_scan.png';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import { updateOperations } from '../../redux/actionCreators/operations';

import {
	AllPartsModal,
	BasicTable,
	CurrentVsTotal,
	MarkComplete,
	ScanOrEnterBarcodeForm,
} from '../../components';
import {
	DARK_MODE,
	OPERATIONS,
	PART_VALIDATION_ERROR,
	REDIRECT_URLS,
  isPuneJlr
} from '../../constants';
import {
	getPartValidationDetailsForSerialNumber,
	updatePartValidation,
	updateStatusFromScanJobDetails,
	validatePart,
} from '../../redux/actionCreators/partValidation';
import { updateReceivePart } from '../../redux/actionCreators/receivePart';
import { pxToRem, responsiveFontSizes } from '../../utils/getFontValue';
import { useAutoFocus, useRedirectToNextScreen } from '../../hooks';
import { useMessageContextManager } from '../../components/MessageOverlay/MessageOverlay';
import { useResolutionScale } from '../../hooks/useResolutionScale';
import clsx from 'clsx';
import { ERROR_MESSAGE } from '../../constants';
import styles from './PartValidationStages.module.scss';
import { markComplete } from '../../redux/actionCreators/printBarcode';
import SkipPart from '../../components/SkipPart/SkipPart';
import Exception from '../../components/Exception/Exception';
import RescanModal from '../../components/ReportModal/RescanModal';
import DefectModal from '../../components/ReportModal/DefectModal';
import { getPartFamiliesToValidate } from '../../utils/utils';
import ValidPartsDetailsPopover from './ValidPartsPopover';
import { BorderRight, SkipNext } from '@mui/icons-material';
import StatusIcon from '../../assets/icons/StatusIcon';
import StyledTable from '../../components/StyledTable/StyledTable';
import TableActionsBar, {
	ProgressHeader,
} from '../../components/TableActionBar/TableActionBar';
import EclipseIcon from '../../assets/icons/EclipseIcon';
import FilledCheckIcon from '../../assets/icons/CheckIcon';
import SkipIcon from '../../assets/icons/SkipIcon';
import { inherits } from 'util';
import CurlyCheckIcon from '../../assets/icons/CurlyCheckIcon';
import { useTorqueColumns } from '../../components/TorqueTable/useTorqueColumns';
import { hasOperationPermission } from '../../utils/operationFlow';
import { toast } from 'react-toastify';
import { getProcessValidationDetailsForSerialNumber } from '../../redux/actionCreators/processValidation';
import { getProcessValidationDetailsForVcNumber } from '../../redux/actionCreators/processValidation';
const ROW_HEIGHT = 38;

const INTIAL_PART_FAMILY_SCAN_DATA = {
	scannedPartNumber: '',
	isPartNumberScanningDone: false,
	isErrorInScanningPartNumber: false,
	scannedSerialNumber: '',
	isSerialNumberScanningDone: false,
	isErrorInScanningSerialNumber: false,
};

const classNames = {
	subtitles: {
		fontSize: '30px',
	},

	paper: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
	},
	tableRow: {
		verticalAlign: 'top',
	},
	tableContainer: {
		height: 3 * ROW_HEIGHT,
	},
	tableContentContainer: {
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
		marginTop: '10px',
		borderBottomLeftRadius: '5px',
		borderBottomRightRadius: '5px',
	},
	heading: {
		fontSize: '20px',
		fontWeight: 600,
		...responsiveFontSizes({ sm: 12, md: 20, lg: 20 }),
	},
	text: {
		display: 'flex',
		justifyContent: 'space-between',
		letterSpacing: 0.5,
		overflow: 'auto',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		fontWeight: 'normal',
		fontSize: pxToRem(16),
		...responsiveFontSizes({ sm: 16, md: 20, lg: 24 }),
	},
	enterSerialNumber: {
		color: '#3070db',
		paddingLeft: 1,
		fontWeight: 700,
		lineHeight: 1.5,
		fontSize: pxToRem(14),
		...responsiveFontSizes({ sm: 14, md: 16, lg: 24 }),
		'&:hover': {
			backgroundColor: 'transparent',
		},
	},
	textInput: {
		borderRadius: 2,
		background: ({ palette }) =>
			palette.mode === DARK_MODE ? 'white' : palette.background.paper,
		paddingLeft: 2,
	},
	buttonStyles: {
		marginRight: 0,
		px: 4,
		background: '#82C1A7',
		borderRadius: 1,
		color: 'white',
		width: 70,

		'&.Mui-disabled': {
			color: 'rgba(0, 0, 0, 0.26)',
			backgroundColor: '#d8d8d8',
		},
	},
	cell: {
		borderBottom: 'none',
		paddingBottom: 0,
	},
};

const PVnG_DEFAULT_COLUMNS = [
	{
		width: 250,
		title: 'Part Family',
		field: 'familyName',
	},
	{
		width: 250,
		title: 'Part Number',
		field: 'partNumber',
		render: (
			prop,
			{
				openEllipsisPopupForEventWithText: handlePopoverOpen,
				closeEllipsisPopup: handlePopoverClose,
				onCopy,
			},
		) => {
			return (
				<Box sx={{ display: 'flex' }}>
					<Typography
						sx={{
							whiteSpace: 'nowrap',
							width: '90%',
							textAlign: 'left',
							letterSpacing: 0.5,
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							fontSize: pxToRem(15),
							...responsiveFontSizes({ sm: 15, md: 17, lg: 21 }),
							opacity: !prop.hasOwnProperty('isErrorInScanningPartFamily')
								? 0.8
								: 1,
							color: !prop.hasOwnProperty('isErrorInScanningPartFamily')
								? null
								: prop.isErrorInScanningPartFamily
									? '#F17C7C'
									: '#82C1A7',
						}}
						onMouseEnter={(e) => handlePopoverOpen(e, prop.partNumber)}
						onMouseLeave={() => handlePopoverClose()}
						onDoubleClick={() => onCopy(prop.partNumber)}
					>
						{prop.partNumber}
					</Typography>
					<ValidPartsDetailsPopover rowData={prop?.validParts} />
				</Box>
			);
		},
	},
	{
		width: 300,
		title: 'Part Description',
		field: 'partDescription',
		render: (
			prop,
			{
				openEllipsisPopupForEventWithText: handlePopoverOpen,
				closeEllipsisPopup: handlePopoverClose,
				onCopy,
			},
		) => {
			return (
				<Typography
					sx={{
						letterSpacing: 0.5,
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						whiteSpace: 'nowrap',
						fontSize: pxToRem(15),
						...responsiveFontSizes({ sm: 15, md: 17, lg: 21 }),
						opacity: !prop.hasOwnProperty('isErrorInScanningPartFamily')
							? 0.8
							: 1,
						color: !prop.hasOwnProperty('isErrorInScanningPartFamily')
							? null
							: prop.isErrorInScanningPartFamily
								? '#F17C7C'
								: '#82C1A7',
					}}
					onMouseEnter={(e) => handlePopoverOpen(e, prop.partDescription)}
					onMouseLeave={() => handlePopoverClose()}
					onDoubleClick={() => onCopy(prop.partDescription)}
				>
					{prop.partDescription}
				</Typography>
			);
		},
	},
	{
		width: 150,
		title: 'Quantity',
		field: 'quantity',
		render: (prop) => {
			// Calculate processed count (scanned + skipped)
			const scanJobResults = prop.scanJobResults || [];
			const totalQuantity = prop.quantity || 0;

			// Count validated and skipped items
			const validatedCount = scanJobResults.filter(
				(result) => !result.skipReason,
			).length;
			const skippedCount = scanJobResults.filter(
				(result) => result.skipReason,
			).length;
			const processedCount = validatedCount + skippedCount;

			return (
				<CurrentVsTotal
					classNames={{
						currentNumber: {
							fontWeight: 700,
							fontSize: pxToRem(16),
							...responsiveFontSizes({ sm: 16, md: 18, lg: 24 }),
						},
						totalNumber: {
							fontSize: pxToRem(13),
							...responsiveFontSizes({ sm: 13, md: 15, lg: 19 }),
						},
					}}
					currentNumber={processedCount}
					totalNumber={totalQuantity}
				/>
			);
		},
	},
	{
		width: 250,
		title: 'Serial Number',
		field: 'displaySerialNumber',
		render: (
			prop,
			{
				openEllipsisPopupForEventWithText: handlePopoverOpen,
				closeEllipsisPopup: handlePopoverClose,
				onCopy,
			},
		) => {
			return (
				<Typography
					sx={{
						letterSpacing: 0.5,
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						whiteSpace: 'nowrap',
						fontSize: pxToRem(15),
						...responsiveFontSizes({ sm: 15, md: 17, lg: 21 }),
						opacity:
							!prop.skipReason &&
								(prop.displaySerialNumber || prop.scannedSerialNumber)
								? 0.8
								: 1,
						color:
							!prop.hasOwnProperty('isErrorInScanningPartFamily') &&
								!prop.skipReason &&
								(prop.displaySerialNumber || prop.scannedSerialNumber)
								? '#82C1A7'
								: '#F17C7C',
					}}
					onMouseEnter={(e) =>
						handlePopoverOpen(
							e,
							prop.displaySerialNumber || prop.scannedSerialNumber,
						)
					}
					onMouseLeave={() => handlePopoverClose()}
					onDoubleClick={() =>
						onCopy(prop.displaySerialNumber || prop.scannedSerialNumber)
					}
				>
					{prop.displaySerialNumber || prop.scannedSerialNumber || '-'}
				</Typography>
			);
		},
	},
	{
		width: 250,
		title: 'Part Validation & Genealogy',
		field: 'partValidation&Genealogy',
		render: (row) => {
			const isSelected = row.isSelected || false;
			const skipReason = row.skipReason;
			const scanJobResults = row.scanJobResults || [];
			const quantity = row.quantity || 0;

			// Check if part is skipped (either at row level or in scanJobResults)
			const isSkipped =
				!!skipReason ||
				scanJobResults.some((result) => result.skipReason) ||
				false;

			// Check if part is fully scanned (all quantities scanned with actual scan results, not skipped)
			const validScanResults = scanJobResults.filter(
				(result) => !result.skipReason,
			);
			const isFullyScanned =
				quantity === validScanResults.length && validScanResults.length > 0;

			// Check if part has any valid scan results (not skipped)
			const hasValidScanResults = validScanResults.length > 0;

			// Determine status and styling
			let status, color, icon;

			if (isSkipped) {
				status = 'Skipped';
				color = '#e47778'; // Red for skipped
				icon = <ReportProblemRoundedIcon color="error" />;
			} else if (isFullyScanned) {
				status = 'Validated';
				color = '#82C1A7'; // Green for validated
				icon = <CheckIcon sx={{ color: '#82C1A7' }} />;
			} else if (hasValidScanResults) {
				status = 'Partial';
				color = '#FFA500'; // Orange for partial
				icon = <CheckIcon sx={{ color: '#FFA500' }} />;
			} else {
				status = 'Pending';
				color = '#e47778'; // Red for pending
				icon = <ReportProblemRoundedIcon color="error" />;
			}

			return (
				<Grid item display="flex">
					{icon}
					<Typography
						component="span"
						sx={{
							paddingLeft: 1,
							letterSpacing: 0.5,
							fontWeight: isSelected ? 700 : 500,
							fontSize: pxToRem(15),
							...responsiveFontSizes({ sm: 15, md: 17, lg: 21 }),
							color: color,
						}}
					>
						{status}
					</Typography>
				</Grid>
			);
		},
	},
	{
		width: 250,
		title: 'Reason to Skip',
		field: 'skipReason',
		columnStyle: {
			color: '#F17C7C',
		},
	},
];

const UpdatePartValidationGenealogy = ({
	partValidation,
	selectedRows,
	themeMode,
	tableRows,
	setTableRows,
	revalidatePart,
	validatePart,
	setAllScanned,
	partSkipSuccessCallback,
	partSkipErrorCallback,
}) => {
	const { isPopupOpen, showMessageOverlay } = useMessageContextManager();
	const [partFamilyScannedData, setPartFamilyScannedData] = useState(
		INTIAL_PART_FAMILY_SCAN_DATA,
	);
	const [skippedSerialNumber, setSkippedSerialNumber] = useState('');
	const [skippedPartNumber, setSkippedPartNumber] = useState('');
	const [successMessage, setSuccessMessage] = useState('');

	const { scanJobDetails } = partValidation;

	const partNumberInputRef = useRef(null);
	const serialNumberInputRef = useRef(null);

	const onPartNumberSubmit = (scannedValue, resetBarcodeValue) => {
		const {
			validParts,
			sequenceNumber,
			familyId,
			partNumber,
			scanJobResultId,
			skipReason,
			partNumberScanningRequired,
			genealogyRequired,
			partPosition,
			scannedPartNumber,
		} = selectedRows[0];

		const successCallback = (updatedPartFamilyScannedData = {}) => {
			closeMesssageOverlay();
			setSuccessMessage('Part Matched');
			setPartFamilyScannedData({
				...partFamilyScannedData,
				scannedPartNumber: scannedValue,
				isPartNumberScanningDone: true,
				isErrorInScanningPartNumber: false,
				...updatedPartFamilyScannedData,
			});
			// Don't reset barcode value here - we need to keep the part number scanned state
			// and move to serial number scanning
			// Focus on serial number input for next scan
			setTimeout(() => {
				if (serialNumberInputRef.current) serialNumberInputRef.current.focus();
			}, 100);
		};

		const errorCallback = () => {
			const rowsData = tableRows.map((partFamily) => {
				if (
					partFamily.familyId === familyId &&
					partFamily.partPosition === partPosition
				)
					return {
						...partFamily,
						scannedValue,
						skippedPartNumber: scannedValue,
						isErrorInScanningPartFamily: true,
					};
				return { ...partFamily };
			});
			setTableRows(rowsData);
			closeMesssageOverlay();
			setSkippedPartNumber(scannedValue);
			setPartFamilyScannedData((prev) => ({
				...prev,
				isPartNumberScanningDone: false,
				isErrorInScanningPartNumber: true,
			}));
			resetBarcodeValue();
			showMessageOverlay({
				contextText:
					PART_VALIDATION_ERROR.ERROR_CONTEXT_TEXT + 'Scanning Part Number',
				info: 'Part did not match',
				error: true,
			});
		};

		const onlyPartNoScanningSuccessCallback = () => {
			successCallback({ ...INTIAL_PART_FAMILY_SCAN_DATA });
		};

		const closeMesssageOverlay = showMessageOverlay({
			contextText: 'Scanning Part Number.',
			loading: true,
		});

		setPartFamilyScannedData((prev) => ({
			...prev,
			scannedPartNumber: scannedValue,
		}));

		// For Logic 3: genealogyRequired = false && partNumberScanningRequired = true
		// Send scanned part number and serial number as null
		const payload = {
			familyId,
			partNumber,
			scannedPartNumber: scannedValue,
			scannedSerialNumber: '',
		};

		if (!genealogyRequired && partNumberScanningRequired) {
			if (skipReason || scannedPartNumber) {
				revalidatePart(
					sequenceNumber,
					scanJobResultId,
					{ ...payload },
					(data) => {
						// Pass the actual response data to successCallback
						successCallback(data);
						// Check if all parts are scanned or skipped
						const allPartsScanned = tableRows.every((item) => {
							return (
								item?.quantity === item?.scanJobResults?.length ||
								item?.skipReason
							);
						});
						setAllScanned(allPartsScanned);
					},
					(error) => {
						errorCallback();
					},
				);
			} else {
				validatePart(
					sequenceNumber,
					{ ...payload },
					() => {
						onlyPartNoScanningSuccessCallback();
						// Check if all parts are scanned or skipped
						const allPartsScanned = tableRows.every((item) => {
							return (
								item?.quantity === item?.scanJobResults?.length ||
								item?.skipReason
							);
						});
						setAllScanned(allPartsScanned);
					},
					(error) => {
						errorCallback();
					},
				);
			}
		}

		// For Logic 2: genealogyRequired = true && partNumberScanningRequired = true
		// Validate part number with backend, then proceed to serial number scanning
		if (genealogyRequired && partNumberScanningRequired) {
			validatePart(
				sequenceNumber,
				{ ...payload },
				() => {
					// On successful validation, set part number as scanned and move to serial number scanning
					successCallback();
				},
				(error) => {
					errorCallback();
				},
			);
		}
	};

	const onSerialNumberSubmit = (scannedValue, resetBarcodeValue) => {
		const {
			sequenceNumber,
			familyId,
			partNumber,
			scanJobResultId,
			skipReason,
			partNumberScanningRequired,
			genealogyRequired,
			partPosition,
			scannedSerialNumber,
		} = selectedRows[0];

		const successCallback = () => {
			closeMesssageOverlay();
			setSuccessMessage('Serial Number Matched');
			setPartFamilyScannedData(INTIAL_PART_FAMILY_SCAN_DATA);
			setTimeout(() => {
				setSuccessMessage('');
				resetBarcodeValue();
			}, 3000);
		};

		const errorCallback = (error) => {
			const rowsData = tableRows.map((partFamily) => {
				if (
					partFamily.familyId === familyId &&
					partFamily.partPosition === partPosition
				)
					return {
						...partFamily,
						scannedValue,
						skippedSerialNumber: scannedValue,
						displaySerialNumber: scannedValue,
						isErrorInScanningPartFamily: true,
					};
				return { ...partFamily };
			});
			setTableRows(rowsData);
			setSkippedSerialNumber(scannedValue);
			closeMesssageOverlay();
			setPartFamilyScannedData((prev) => ({
				...prev,
				isSerialNumberScanningDone: false,
				isErrorInScanningSerialNumber: true,
			}));
			resetBarcodeValue();
			showMessageOverlay({
				contextText:
					PART_VALIDATION_ERROR.ERROR_CONTEXT_TEXT + 'Scanning Serial Number',
				info: error.response.data.message,
				error: true,
			});
		};

		const closeMesssageOverlay = showMessageOverlay({
			contextText: 'Scanning Serial Number.',
			loading: true,
		});

		setPartFamilyScannedData((prev) => ({
			...prev,
			scannedSerialNumber: scannedValue,
		}));

		// For Logic 1 & 2: Send scanned serial number and part number based on logic
		const scannedPartNumber =
			genealogyRequired && !partNumberScanningRequired
				? ''
				: partFamilyScannedData.scannedPartNumber; // Use the previously scanned part number for Logic 2

		const payload = {
			familyId,
			partNumber,
			scannedPartNumber: scannedPartNumber,
			scannedSerialNumber: scannedValue,
		};

		if (skipReason || scannedSerialNumber) {
			revalidatePart(
				sequenceNumber,
				scanJobResultId,
				{ ...payload },
				(data) => {
					// Pass the actual response data to successCallback
					successCallback(data);
					// Check if all parts are scanned or skipped
					const allPartsScanned = tableRows.every((item) => {
						return (
							item?.quantity === item?.scanJobResults?.length ||
							item?.skipReason
						);
					});
					setAllScanned(allPartsScanned);
				},
				(error) => {
					errorCallback(error);
				},
			);
		} else {
			validatePart(
				sequenceNumber,
				{ ...payload },
				() => {
					successCallback();
					// Check if all parts are scanned or skipped
					const allPartsScanned = tableRows.every((item) => {
						return (
							item?.quantity === item?.scanJobResults?.length ||
							item?.skipReason
						);
					});
					setAllScanned(allPartsScanned);
				},
				(error) => {
					errorCallback(error);
				},
			);
		}
	};

	// Removed redundant useEffect - tableRows are already managed by parent component

	const isSkipDisabled = () => {
		const selectedRow = selectedRows[0];
		const latestPartToSkip = tableRows.find(
			(row) =>
				row.familyId === selectedRow.familyId &&
				!(row.scannedPartNumber || row.scannedSerialNumber || row.skipReason),
		);
		if (selectedRow.partPosition === latestPartToSkip.partPosition)
			return false;
		return true;
	};


	const ScanInputFields = ({
		selectedRows,
		partFamilyScannedData,
		onSerialNumberSubmit,
		onPartNumberSubmit,
		themeMode,
	}) => {
		const {
			partNumberScanningRequired,
			genealogyRequired,
			isErrorInScanningPartFamily,
		} = selectedRows[0];

		const { inputRef } = useAutoFocus({
			timeout: 10000,
			enabled: true,
			componentId: 'scan-vin-input',
			onFocus: () => {

			},
		});

		// Determine what to scan based on the three logic conditions
		let shouldScanPartNumber = false;
		let shouldScanSerialNumber = false;
		let scanLabel = '';
		let onSubmitHandler = null;

		let currentInputRef = inputRef;

		if (genealogyRequired && !partNumberScanningRequired) {
			// Logic 1: Only scan serial number
			shouldScanSerialNumber = true;
			scanLabel = 'SCAN SERIAL NUMBER';
			onSubmitHandler = onSerialNumberSubmit;
			currentInputRef = serialNumberInputRef;
		} else if (partNumberScanningRequired && genealogyRequired) {
			// Logic 2: Scan part number first, then serial number
			if (!partFamilyScannedData.isPartNumberScanningDone) {
				// First scan: Part Number
				shouldScanPartNumber = true;
				scanLabel = 'SCAN PART NUMBER';
				onSubmitHandler = onPartNumberSubmit;
				currentInputRef = partNumberInputRef;
			} else {
				// Second scan: Serial Number (after part number is validated)
				shouldScanSerialNumber = true;
				scanLabel = 'SCAN SERIAL NUMBER';
				onSubmitHandler = onSerialNumberSubmit;
				currentInputRef = serialNumberInputRef;
			}
		} else if (!genealogyRequired && partNumberScanningRequired) {
			// Logic 3: Only scan part number
			shouldScanPartNumber = true;
			scanLabel = 'SCAN PART NUMBER';
			onSubmitHandler = onPartNumberSubmit;
			currentInputRef = partNumberInputRef;
		}

		useEffect(() => {
			if (currentInputRef.current) {
				currentInputRef.current.focus();
			}
		}, [currentInputRef]);

		// If no scanning is required, don't render anything
		if (!shouldScanPartNumber && !shouldScanSerialNumber) {
			return null;
		}

		// Determine if there's an error state
		const isError =
			isErrorInScanningPartFamily &&
			((shouldScanPartNumber &&
				partFamilyScannedData.isErrorInScanningPartNumber) ||
				(shouldScanSerialNumber &&
					partFamilyScannedData.isErrorInScanningSerialNumber));

		return (
			<Grid
				item
				container
				direction="column"
				alignItems="end"
				columnSpacing={2}
				sx={{ opacity: selectedRows.length == 1 ? '100%' : '50%' }}
			>
				<Grid item display="flex" alignItems="center">
					{isError ? (
						<Typography variant="h3" color="error">
							RESCAN {scanLabel.split(' ')[1]}
						</Typography>
					) : (
						<Typography variant="h3" sx={{ color: '#27C8F7' }}>
							{scanLabel}
						</Typography>
					)}
					<Box
						item
						sx={{
							height: { xs: 35, md: 40, lg: 60 },
							width: { xs: 75, md: 85, lg: 130 },
						}}
					>
						<img
							src={themeMode === DARK_MODE ? darkBarcode : lightBarcode}
							alt=""
							style={{
								height: '100%',
								width: '100%',
								objectFit: 'cover',
							}}
						/>
					</Box>
				</Grid>
				<Grid item xs={12} sx={{ width: { sm: '75%', md: '60%' } }} pt={1}>
					<ScanOrEnterBarcodeForm
						enableAutoEnter={true}
						inputRef={currentInputRef}
						inputProps={{
							disabled: selectedRows.length !== 1,
						}}
						onSubmit={onSubmitHandler}
						placeholder={
							shouldScanPartNumber ? 'Part Number Scan' : 'Serial Number Scan'
						}
					/>
				</Grid>
			</Grid>
		);
	};

	// Then in your main component:
	const renderInputFields = () => {
		return (
			<ScanInputFields
				selectedRows={selectedRows}
				partFamilyScannedData={partFamilyScannedData}
				onSerialNumberSubmit={onSerialNumberSubmit}
				onPartNumberSubmit={onPartNumberSubmit}
				themeMode={themeMode}
			/>
		);
	};

	useEffect(() => {
		if (!isPopupOpen) {
			if (partNumberInputRef.current) partNumberInputRef.current.focus();
			if (serialNumberInputRef.current) serialNumberInputRef.current.focus();
		}
	}, [selectedRows, isPopupOpen]);

	return (
		<>
			<Grid item xs={5} display="flex" flexWrap="wrap" alignItems="flex-end">
				<Grid item pt={1}>
					{!successMessage &&
						selectedRows.length === 1 &&
						!(
							selectedRows[0]?.skipReason ||
							selectedRows[0]?.scannedSerialNumber ||
							selectedRows[0]?.scannedPartNumber
						) && (
							<SkipPart
								// setSecondApiStop={setSecondApiStop}
								skippart={selectedRows[0]}
								skippedPartNumber={selectedRows[0].skippedPartNumber}
								skippedSerialNumber={selectedRows[0].skippedSerialNumber}
								disableBtn={isSkipDisabled()}
								hoverMessage="Please select the quantity in sequential manner"
								successCallback={partSkipSuccessCallback}
								errorCallback={partSkipErrorCallback}
								currentPartNumber={scanJobDetails.findIndex(
									(part) => part.familyId === selectedRows[0]?.familyId,
								)}
							/>

						)}
				</Grid>
				{successMessage && (
					<>
						<CheckIcon
							color="primary"
							sx={{
								fontSize: {
									lg: 34,
								},
							}}
						/>
						<Typography
							variant="h4"
							component="span"
							color="primary"
							fontWeight={400}
							paddingLeft={1}
						>
							{successMessage}
						</Typography>
					</>
				)}
			</Grid>
			<Grid item xs={7}>
				{!successMessage && !!selectedRows.length && renderInputFields()}
			</Grid>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		receivePart: state.receivePart,
		partValidation: state.partValidation,
		themeMode: state.theme.themeMode,
		isMobileStation: state.user.isMobileStation,
		currentLineItem: state.station.currentLineItem,
		modeType: state.modeType,
		operations: state.operations,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getPartValidationDetailsForSerialNumber: (
		successCallback,
		errorCallback,
		sequenceNumber,
	) =>
		dispatch(
			getPartValidationDetailsForSerialNumber(
				successCallback,
				errorCallback,
				sequenceNumber,
			),
		),
	validatePart: (sequenceNumber, payload, successCallback, errorCallback) =>
		dispatch(
			validatePart(sequenceNumber, payload, successCallback, errorCallback),
		),
	updatePartValidation: (data) => dispatch(updatePartValidation(data)),
	updateReceivePart: (data) => dispatch(updateReceivePart(data)),
	markComplete: (successCallback, errorCallback, sequenceNumber) =>
		dispatch(markComplete(successCallback, errorCallback, sequenceNumber)),

});

export const PartValidationStages = ({
	receivePart,
	partValidation,
	isEmbedded = false,
	onCompletionOverride = null,
	themeMode,
	getPartValidationDetailsForSerialNumber,
	validatePart,
	updatePartValidation,
	updateReceivePart,
	markComplete,
	isMobileStation,
	currentLineItem,
	modeType,
	operations,
}) => {
	const { handleNext } = useOutletContext();
	const dispatch = useDispatch();
	const [allScanned, setAllScanned] = useState(false);
	const redirect = useRedirectToNextScreen();
	const [currentPartNumber, setCurrentPartNumber] = useState(null);
	const [isPartNumberProcessing, setIsPartNumberProcessing] = useState(true);
	const secondApiIntervalRef = useRef(null);
	const [secondApiStop, setSecondApiStop] = useState(true);
	const [machineOperationCurrent, setMachineOperationCurrent] = useState(0);
	const [machineOperationTotal, setMachineOperationTotal] = useState(0);

	useEffect(() => {
		// Keep Redux operation aligned with this route so "Next Operation" works (e.g. SCAN -> MACHINE).
		dispatch(updateOperations({ currentOperation: OPERATIONS.PART_VALIDATION }));
	}, [dispatch]);




	const stopSecondApiPolling = () => {
		if (secondApiIntervalRef.current) {
			clearInterval(secondApiIntervalRef.current);
			secondApiIntervalRef.current = null;
		}
	};
	const { inputRef } = useAutoFocus({
		timeout: 10000, // 10 seconds
		enabled: true,
		componentId: 'part-validation-input', // Unique ID for global context
		onFocus: () => {

		},
	});

	// Resolution scaling for responsive design
	const { is4K, isAssemblyLine, scaleValue, getResponsiveValue } =
		useResolutionScale();

	// Calculate responsive values for table columns
	const responsiveFontSize = getResponsiveValue({
		laptop: '16px',
		fhd: '18px',
		qhd: '20px',
		'4k': '24px',
		'4k_plus': '28px',
	});

	const responsiveIconSize = scaleValue(28);

	const responsiveColumnWidths = {
		partName: getResponsiveValue({
			laptop: 160,
			fhd: 180,
			qhd: 200,
			'4k': 240,
			'4k_plus': 280,
		}),
		partNumber: getResponsiveValue({
			laptop: 120,
			fhd: 140,
			qhd: 160,
			'4k': 180,
			'4k_plus': 200,
		}),
		description: getResponsiveValue({
			laptop: 180,
			fhd: 200,
			qhd: 220,
			'4k': 260,
			'4k_plus': 300,
		}),
		qty: getResponsiveValue({
			laptop: 60,
			fhd: 70,
			qhd: 80,
			'4k': 90,
			'4k_plus': 100,
		}),
		serialNumber: getResponsiveValue({
			laptop: 140,
			fhd: 160,
			qhd: 180,
			'4k': 220,
			'4k_plus': 260,
		}),
		status: getResponsiveValue({
			laptop: 100,
			fhd: 120,
			qhd: 140,
			'4k': 160,
			'4k_plus': 180,
		}),
	};

	const PV_DEFAULT_COLUMNS = [
		{
			width: 300,
			title: 'VIN',
			field: 'serialNumber',
			render: (row, theme) => {
				return (
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							gap: 1,
							justifyContent: 'center',
						}}
					>
						<Typography
							sx={{
								fontSize: getResponsiveValue({
									laptop: '12px',
									fhd: '14px',
									qhd: '16px',
									'4k': '18px',
									'4k_plus': '20px',
								}),
								fontFamily: "'Uni Neue', sans-serif",
								fontWeight: 'bold',
							}}
						>
							{row.serialNumber}
						</Typography>
					</Box>
				);
			},
		},
		{
			width: 240,
			title: 'KSPEC',
			field: 'parentPartNumber',
			render: (row, theme) => {
				return (
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							gap: 1,
							justifyContent: 'center',
						}}
					>
						<Typography
							sx={{
								fontSize: getResponsiveValue({
									laptop: '12px',
									fhd: '14px',
									qhd: '16px',
									'4k': '18px',
									'4k_plus': '20px',
								}),
								fontFamily: "'Uni Neue', sans-serif",
								fontWeight: 'bold',
							}}
						>
							{row.parentPartNumber}
						</Typography>
					</Box>
				);
			},
		},
		{
			width: 450,
			title: isPuneJlr() ? 'Model' : 'KSPEC Description',
			field: isPuneJlr() ? 'model' : 'description',
			render: (row, theme) => {
				return (
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							gap: 1,
							justifyContent: 'center',
						}}
					>
						<Typography
							sx={{
								fontSize: getResponsiveValue({
									laptop: '12px',
									fhd: '14px',
									qhd: '16px',
									'4k': '18px',
									'4k_plus': '20px',
								}),
								fontFamily: "'Uni Neue', sans-serif",
								fontWeight: 'bold',
							}}
						>
							{isPuneJlr() ? (currentLineItem?.model || row.parentPartDescription) : row.parentPartDescription}
						</Typography>
					</Box>
				);
			},
		},
	];
	const [skippedTorqueRow, setSkippedTorqueRow] = useState(null);


	const TEXT_COLUMNS = [
		{
			title: 'Part Name',
			field: 'familyName',
			label: 'Part Name',
			width: responsiveColumnWidths.partName,
			sortable: true,
			render: (row, theme) => {
				return (
					<Typography
						sx={{
							fontFamily: "'Uni Neue', sans-serif",
							fontWeight: 800,
							fontSize: responsiveFontSize,
							textAlign: 'center',
						}}
					>
						{row.familyName}
					</Typography>
				);
			},
			render: (row, theme) => {
				return (
					<Typography
						sx={{
							fontFamily: "'Uni Neue', sans-serif",
							fontWeight: 800,
							fontSize: responsiveFontSize,
							textAlign: 'center',
						}}
					>
						{row.familyName}
					</Typography>
				);
			},
		},
		{
			title: 'Part Number',
			field: 'partNumber',
			label: 'Part Number',
			width: responsiveColumnWidths.partNumber,
			sortable: true,
			render: (row, theme) => {
				return (
					<Typography
						sx={{
							fontFamily: "'Uni Neue', sans-serif",
							fontWeight: 800,
							fontSize: responsiveFontSize,
							textAlign: 'center',
						}}
					>
						{row.partNumber}
					</Typography>
				);
			},
		},
		{
			title: 'Description',
			field: 'partDescription',
			label: 'Description',
			width: responsiveColumnWidths.description,
			sortable: true,
			render: (row, theme) => {
				return (
					<Typography
						sx={{
							fontFamily: "'Uni Neue', sans-serif",
							fontWeight: 800,
							fontSize: responsiveFontSize,
							textAlign: 'center',
						}}
					>
						{row.partDescription}
					</Typography>
				);
			},
		},
		{
			title: 'Qty',
			field: 'quantity',
			label: 'Qty',
			width: responsiveColumnWidths.qty,
			render: (row) => {
				// Calculate processed count (scanned + skipped)
				const scanJobResults = row.scanJobResults || [];
				const validatedCount = scanJobResults.filter(
					(result) => !result.skipReason,
				).length;
				const skippedCount = scanJobResults.filter(
					(result) => result.skipReason,
				).length;
				const processedCount = validatedCount + skippedCount;
				const totalQuantity = row.quantity || 0;

				return (
					<Typography
						sx={{
							fontFamily: "'Uni Neue', sans-serif",
							fontWeight: 800,
							fontSize: responsiveFontSize,
							textAlign: 'center',
						}}
					>
						{processedCount}/{totalQuantity}
					</Typography>
				);
			},
			sortable: true,
		},
		{
			title: 'Serial Number',
			field: 'scannedSerialNumber',
			label: 'Serial Number',
			width: responsiveColumnWidths.serialNumber,
			render: (row) => {
				// Get scanned serial numbers from scanJobResults
				const scannedSerialNumbers =
					row.scanJobResults
						?.filter(
							(result) => !result.skipReason && result.scannedSerialNumber,
						)
						?.map((result) => result.scannedSerialNumber)
						?.join(', ') || '-';

				return (
					<Typography
						sx={{
							fontFamily: "'Uni Neue', sans-serif",
							fontWeight: 800,
							fontSize: responsiveFontSize,
							textAlign: 'center',
						}}
					>
						{scannedSerialNumbers}
					</Typography>
				);
			},
			sortable: true,
		},
		{
			title: 'Status',
			field: 'status',
			label: 'Status',
			width: responsiveColumnWidths.status,
			render: (row, theme) => {
				const isDark = theme.palette.mode === 'dark';
				const status = row.status;
				const size = scaleValue(28);

				let icon, color;

				switch (status) {
					case 'Validated':
						icon = <CurlyCheckIcon style={{ width: size, height: size }} />;
						color = isDark ? '#4CAF50' : '#097F4A';
						break;
					case 'Skipped':
						icon = <SkipNext style={{ width: size, height: size }} />;
						color = 'rgba(236, 176, 64, 1)';
						break;
					case 'Pending':
						icon = <EclipseIcon style={{ width: size, height: size }} />;
						color = isDark ? '#FFFFFF' : '#202020';
						break;
					default:
						icon = <EclipseIcon style={{ width: size, height: size }} />;
						color = isDark ? '#FFFFFF' : '#202020';
				}

				return (
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							gap: 1,
							justifyContent: 'center',
						}}
					>
						{React.cloneElement(icon, {
							style: { ...(icon.props?.style || {}), color },
						})}
					</Box>
				);
			},
		},
	];
	const [scanColumns, setScanColumns] = useState([...TEXT_COLUMNS]);
	const [scanFilters, setScanFilters] = useState({});
	const [displayedRows, setDisplayedRows] = useState([]); // filtered rows
	const [selectedPvRows, setSelectedPvRows] = useState([]);
	const [isAutoSelected, setIsAutoSelected] = useState(false);
	// Add this at the top inside the component:
	const [selectedGlobalRow, setSelectedGlobalRow] = useState(null);


	const handleSelectionChange = (selectedIds, row) => {
		setSelectedTorqueRows([]);
		setSkippedTorqueRow(null);
		setSelectedPvRows(selectedIds || []);

		if (selectedIds && selectedIds.length === 1) {
			const selectedRow = row || displayedRows.find(
				(r) => r.id == selectedIds[0] || r.familyId == selectedIds[0],
			);

			if (selectedRow) {
				setSelectedGlobalRow(selectedRow);
				// If selecting a family (no partPosition), target next pending instance
				if (!selectedRow.partPosition && selectedRow.scanJobResults) {
					const totalQty = selectedRow.quantity || 1;
					const currentScannedCount = selectedRow.scanJobResults.length;
					if (currentScannedCount < totalQty) {
						setSkippart({
							...selectedRow,
							partPosition: currentScannedCount + 1,
							scanJobResultId: null
						});
						return;
					}
				}
				setSkippart(selectedRow);
			}
		} else {
			setSelectedGlobalRow(null);
			setSkippart(null);
		}
	};


	const [torqueTableRows, setTorqueTableRows] = useState([]);

	const torqueTableHeader = useTorqueColumns();

	const [selectedTorqueRows, setSelectedTorqueRows] = useState([]);

	const hasMachineOperation = hasOperationPermission(
		OPERATIONS.MACHINE,
		operations.allowedOperations,
	);
	const normalize = (v = '') => {
		if (!v) return '';
		return v
			.trim()
			.toLowerCase()
			.replace(/\s+/g, ' ')
			.replace(/\s*__\s*/g, '__')
			.replace(/\s*_\s*/g, '_');
	};

	const isSuccessStatus = (status) => {
		if (!status) return false;
		const s = status.toString().toUpperCase();
		return s === 'OK' || s === 'SUCCESS' || s === 'VALIDATED' || s === 'PASS' || s === 'APPLIED';
	};


	const buildStatusMap = (serialResponse) => {
		const map = {};
		const machineDataArr = serialResponse?.machineData || [];

		machineDataArr.forEach(machine => {
			const machineId = machine.machineId;

			machine.processParameters?.forEach(param => {
				const key = `${machineId}_${normalize(param.key)}`;

				if (!map[key]) map[key] = {};

				// Use batchNumber as index.
				if (param.batchNumber !== undefined && param.batchNumber !== null) {
					map[key][param.batchNumber] = {
						status: param.status,
						isSkipped: param.isSkipped
					};
				}
			});
		});

		return map;
	};



	const mergeTorqueStatus = (vcRows = [], serialResponse = {}) => {
		const statusMap = buildStatusMap(serialResponse);

		return vcRows.map(row => {
			const mapKey = `${row.machineId}_${normalize(row.parameterKey)}`;
			const batchStatusMap = statusMap[mapKey] || {};
			const qty = row.quantity ?? 1;

			const getBatchData = (i) => {
				let data = batchStatusMap[i + 1];
				if (data === undefined && i === 0) data = batchStatusMap[0];
				// When the machine reports a non-sequential batchNumber (e.g. retries use
				// batchNumber=2 but the parameter has quantity=1), fall back to whichever
				// single batch exists in the map so the status isn't lost.
				if (data === undefined && i === 0) {
					const keys = Object.keys(batchStatusMap);
					if (keys.length === 1) data = batchStatusMap[keys[0]];
				}
				// Pune JLR: row.batchNumber (from API spread) is the definitive batch key
				if (data === undefined && isPuneJlr() && row.batchNumber != null) {
					data = batchStatusMap[row.batchNumber];
				}
				return data || null;
			};

			// Actual batchNumber to send in skip requests for each index position
			const getActualBatchNum = (i) => {
				if (batchStatusMap[i + 1] !== undefined) return i + 1;
				if (i === 0 && batchStatusMap[0] !== undefined) return 0;
				if (i === 0) {
					const keys = Object.keys(batchStatusMap).map(Number);
					if (keys.length === 1) return keys[0];
				}
				// Pune JLR: use the row's own batchNumber from the API
				if (isPuneJlr() && row.batchNumber != null && batchStatusMap[row.batchNumber] !== undefined) {
					return row.batchNumber;
				}
				return i + 1;
			};

			const executionStatuses = Array.from({ length: qty }, (_, i) => {
				const data = getBatchData(i);
				if (!data) return null;
				if (data.isSkipped === true) return 'skipped';
				if (isSuccessStatus(data.status)) return true;
				if (data.status && data.status.toString().toUpperCase() === 'NOK') return false;
				return null;
			});

			const batchRawStatuses = Array.from({ length: qty }, (_, i) => {
				const data = getBatchData(i);
				if (!data) {
					if (isPuneJlr()) {
						const fallback = row.paramStatus || row.status;
						return (fallback && fallback.toUpperCase() !== 'PENDING') ? fallback : 'PENDING';
					}
					return 'PENDING';
				}
				if (data.isSkipped === true) return 'SKIPPED';
				const statusValue = data.status;
				if (isPuneJlr() && (!statusValue || statusValue.toUpperCase() === 'PENDING')) {
					const fallback = row.paramStatus || row.status;
					if (fallback && fallback.toUpperCase() !== 'PENDING') {
						return fallback;
					}
				}
				return statusValue || 'PENDING';
			});

			const batchActualNumbers = isPuneJlr()
				? Array.from({ length: qty }, (_, i) => getActualBatchNum(i))
				: Array.from({ length: qty }, (_, i) => i + 1);

			let status = 'Pending';
			if (executionStatuses.every(v => v === true || v === 'skipped')) {
				status = executionStatuses.every(v => v === 'skipped') ? 'SKIPPED' : 'OK';
			} else if (executionStatuses.some(v => v === false)) {
				status = 'NOK';
			} else if (executionStatuses.some(v => v === true || v === 'skipped')) {
				status = 'Partial';
			}

			return {
				...row,
				status,
				executionStatuses,
				batchRawStatuses,
				batchActualNumbers,
			};
		});
	};



	// Initialize receivePart if it's not set but currentLineItem has serialNumber
	useEffect(() => {
		if (!receivePart.serialNumber && currentLineItem?.serialNumber) {
			updateReceivePart({ serialNumber: currentLineItem.serialNumber });
		}
	}, [currentLineItem?.serialNumber, receivePart.serialNumber]);

	const addPendingStatus = (rows) => {
		return rows.map((row) => ({
			...row,
			status: "Pending",
		}));
	};

	const callSecondApi = (serialNumber) => {
		if (!serialNumber) return;

		const successCallback = (data) => {
			setTorqueTableRows((prevRows) =>
				mergeTorqueStatus(prevRows, data)
			);

		};

		const errorCallback = (error) => {
			console.error(
				'Second API (getProcessValidationDetailsForSerialNumber) error:',
				error
			);
			setTorqueTableRows([]);
		};

		dispatch(
			getProcessValidationDetailsForSerialNumber(
				serialNumber,
				successCallback,
				errorCallback
			)
		);
	};


	// Machine operation API calls - only run when MACHINE operation is enabled
	useEffect(() => {
		// Only run machine API calls if MACHINE operation is in allowedOperations
		if (!hasMachineOperation) {
			return;
		}

		// Get serial number from multiple sources (priority order)
		// 1. partValidation.serialNumber (set after part validation)
		// 2. receivePart.serialNumber (set when receiving part)
		// 3. currentLineItem.serialNumber (set from backend)
		const serialNumber = partValidation.serialNumber || receivePart.serialNumber || currentLineItem?.serialNumber;


		if (!serialNumber) {
			return;
		}


		// };
		const firstSuccessCallback = (data) => {
			if (!Array.isArray(data)) {
				setTorqueTableRows([]);
				return;
			}

			const validMachines = data.filter(
				(machine) => machine.machineId !== 50001
			);

			const baseRows = validMachines.flatMap((machine) =>
				(machine.parameters || []).map((param, index) => {
					const parameterKey = param.parameterKey || param.key || '';
					return {
						...param,
						parameterKey,
						quantity: param.quantity ?? 1,
						machineId: machine.machineId,
						id: param.id || `${machine.machineId}-${parameterKey}-${index}`,
						status: 'Pending',
						paramStatus: param.status,
					};
				})
			);

			setTorqueTableRows(baseRows);
		};

		const firstErrorCallback = (error) => {
			console.error('First API (getProcessValidationDetailsForVcNumber) error:', error);
			console.error('Error response:', error?.response?.data);
			console.error('Error status:', error?.response?.status);
			setTorqueTableRows([]);
		};

		dispatch(
			getProcessValidationDetailsForVcNumber(
				serialNumber,
				firstSuccessCallback,
				firstErrorCallback,
			),
		);

		// --- SECOND API: Check completion status every 10 seconds ---
		secondApiIntervalRef.current = setInterval(() => {

			if (secondApiStop) { callSecondApi(serialNumber); }


		}, 5000);


		// cleanup
		return () => {
			if (secondApiIntervalRef.current) {
				clearInterval(secondApiIntervalRef.current);
				secondApiIntervalRef.current = null;

			}
		};
	}, [hasMachineOperation, partValidation.serialNumber, secondApiStop, receivePart.serialNumber, currentLineItem?.serialNumber, isMobileStation]);

	const handleTorqueSelectionChange = (selectedIds) => {
		setSelectedPvRows([]);
		setSelectedGlobalRow(null);

		// Allow multiple row selection for Fail Forward/Skip logic
		setSelectedTorqueRows(selectedIds || []);

		if (selectedIds && selectedIds.length > 0) {
			// For backward compatibility, set skippedTorqueRow to first selected row
			// but the skip logic will process all selected rows
			const firstSelectedRow = torqueTableRows.find(row =>
				selectedIds.includes(row.id) || selectedIds.includes(String(row.id))
			);

			setSkippedTorqueRow(firstSelectedRow);
			setSelectedGlobalRow(firstSelectedRow);
		} else {
			setSkippedTorqueRow(null);
			setSelectedGlobalRow(null);
		}
	};



	const pvData = [
		{
			serialNumber: receivePart.serialNumber,
			parentPartNumber: partValidation.parentPartNumber,
			parentPartDescription: partValidation.parentPartDescription,
		},
	];

	const { scanJobDetails = [] } = partValidation;
	const displayedRowsMapCheckbox = useMemo(() => {
		if (!displayedRows) return [];
		// Determine first pending row (sequential target)

		const firstPending = displayedRows.find(
			(row) => {
				const isScanPending = row.scanJobResults?.length < row.quantity;

				if (isScanPending) return true;
				return false;
			},
		);
		const firstPendingId = firstPending?.id;

		return displayedRows.map((row) => ({
			...row,
			// Only the sequential current row shows an enabled checkbox
			showCheckBox: row.id === firstPendingId,
		}));
	}, [displayedRows]);

	// Calculate responsive table heights using resolution scaling
	const rowHeight = isAssemblyLine ? 120 : 60;
	const tableHeight = 8 * rowHeight; // 8 rows for main table

	// Update displayedRows when scanJobDetails changes
	useEffect(() => {
		const rowsWithIds = (scanJobDetails || []).map((part, index) => ({
			...part,
			id: part.familyId || `part-${index}`, // Use familyId as unique ID or fallback to index
		}));
		const output = updateStatusFromScanJobDetails(rowsWithIds);
		setDisplayedRows(output);

		// Auto-select the first pending part (sequential validation)
		if (output && output.length > 0) {
			const firstPending = output.find(
				(row) => row.status !== 'Validated' && row.status !== 'Skipped',
			);
			if (firstPending && firstPending.id) {
				setSelectedPvRows([firstPending.id]);
				setIsAutoSelected(true);
			} else {
				// No pending parts, clear selection
				setSelectedPvRows([]);
				setIsAutoSelected(false);
			}
		}
	}, [scanJobDetails]);
	const partValidationCurrent =
		scanJobDetails?.reduce((total, part) => {
			const scanJobResults = part.scanJobResults || [];
			const validatedCount = scanJobResults.filter(
				(result) => !result.skipReason,
			).length;
			const skippedCount = scanJobResults.filter(
				(result) => result.skipReason,
			).length;
			return total + validatedCount + skippedCount;
		}, 0) || 0;

	const partValidationTotal =
		scanJobDetails?.reduce(
			(total, part) => total + (part.quantity || 0),
			0,
		) || 0;
	const isMachineRowCompleted = (row) => {
		// console.log("row", row)
		if (!Array.isArray(row.executionStatuses) || row.executionStatuses.length === 0) {
			return false;
		}

		if (row.executionStatuses.some(v => v === false || v === null)) {
			return false;
		}

		// ✅ saare OK ya Skipped ho to hi count hoga
		return row.executionStatuses.every(v => v === true || v === 'skipped');
	};


	useEffect(() => {
		if (!hasMachineOperation || !Array.isArray(torqueTableRows)) {
			setMachineOperationCurrent(0);
			setMachineOperationTotal(0);
			return;
		}

		const completedCount = torqueTableRows.filter(isMachineRowCompleted).length;

		setMachineOperationCurrent(completedCount);
		setMachineOperationTotal(torqueTableRows.length);
	}, [torqueTableRows, hasMachineOperation]);



	const {
		familyId,
		familyName,
		partNumber,
		partDescription,
		quantity,
		scanJobResults = [],
		validParts,
		genealogyRequired,
		partNumberScanningRequired,
	} = scanJobDetails[currentPartNumber] || {};

	const [isDetailsModalOpen, setIsDetailModalOpen] = useState(false);
	const [isReportModalOpen, setIsReportModalOpen] = useState(false);
	const [isDefectModalOpen, setIsDefectModalOpen] = useState(false);

	const [partFamilyScannedData, setPartFamilyScannedData] = useState(() => {
		const storedPartNumber = localStorage.getItem('scannedPartNumber');
		if (storedPartNumber) {
			return {
				...INTIAL_PART_FAMILY_SCAN_DATA,
				scannedPartNumber: storedPartNumber,
				isPartNumberScanningDone: true,
			};
		}
		return INTIAL_PART_FAMILY_SCAN_DATA;
	});
	const [skippedSerialNumber, setSkippedSerialNumber] = useState('');
	const [skippedPartNumber, setSkippedPartNumber] = useState('');
	const [successMessage, setSuccessMessage] = useState('');

	const [tableRows, setTableRows] = useState(null);

	const [noPartFamilyConfigured, setNoPartFamilyConfigured] = useState(false);
	const [skippart, setSkippart] = useState(null);

	const { isPopupOpen, showMessageOverlay } = useMessageContextManager();

	const openDetailsModal = () => setIsDetailModalOpen(true);
	const closeDetailsModal = () => {
		if (inputRef.current) inputRef.current.focus();
		setIsDetailModalOpen(false);
	};

	const openReportModal = () => setIsReportModalOpen(true);
	const closeReportModal = () => setIsReportModalOpen(false);

	const redirectToNextScreen = (scanJobDetails) => {
		// Find the next part that needs validation in sequential order
		const nonScannedPartFamilyIndex = scanJobDetails.findIndex((scanJob) => {
			const results = scanJob.scanJobResults || [];
			const needed = scanJob.quantity || 0;
			return results.length < needed;
		});

		// Reset scanning state
		setPartFamilyScannedData(INTIAL_PART_FAMILY_SCAN_DATA);
		setSkippedSerialNumber('');
		setSkippedPartNumber('');
		setIsPartNumberProcessing(false);

		if (nonScannedPartFamilyIndex === -1) {
			setCurrentPartNumber(scanJobDetails.length - 1);
			setSelectedPvRows([]);
		} else {
			setCurrentPartNumber(nonScannedPartFamilyIndex);
			const nextId =
				scanJobDetails[nonScannedPartFamilyIndex]?.familyId ||
				`part-${nonScannedPartFamilyIndex}`;
			setSelectedPvRows([nextId]);
		}
	};

	const resetState = () => {
		setPartFamilyScannedData(INTIAL_PART_FAMILY_SCAN_DATA);
		setIsPartNumberProcessing(false);
	};

	const onPartSubmitGenelogyAndPartValidation = (
		scannedValue,
		resetBarcodeValue,
	) => {
		// Prevent multiple submissions
		if (isPartNumberProcessing) {
			return;
		}

		setIsPartNumberProcessing(true);
		const closeMesssageOverlay = showMessageOverlay({
			contextText: 'Scanning Part Number.',
			loading: true,
		});

		// Always pick the next pending row sequentially
		const selectedPart = displayedRows.find(
			(row) => row.status !== 'Validated' && row.status !== 'Skipped',
		);
		if (!selectedPart) {
			closeMesssageOverlay();
			setIsPartNumberProcessing(false);
			showMessageOverlay({
				contextText: 'Please select a part to validate',
				error: true,
			});
			resetBarcodeValue();
			return;
		}

		// Update state to show scanned part number
		setPartFamilyScannedData((prev) => ({
			...prev,
			scannedPartNumber: scannedValue,
		}));


		// For Logic 2: genealogyRequired = true && partNumberScanningRequired = true
		// Perform UI-side validation of the part number with a simulated delay to show the loader
		setTimeout(() => {
			const isValidPart = selectedPart.validParts
				? selectedPart.validParts.includes(scannedValue)
				: selectedPart.partNumber === scannedValue;

			if (isValidPart) {
				// On successful UI validation, set part number as scanned and move to serial number scanning
				closeMesssageOverlay();
				setSuccessMessage('Part Number Matched');

				// Store that scanned part number in local storage as requested
				localStorage.setItem('scannedPartNumber', scannedValue);

				setPartFamilyScannedData((prev) => ({
					...prev,
					scannedPartNumber: scannedValue,
					isPartNumberScanningDone: true,
					isErrorInScanningPartNumber: false,
				}));
				setIsPartNumberProcessing(false);

				// Clear the input and focus for the next scan (serial number) after a short delay
				setTimeout(() => {
					setSuccessMessage('');
					resetBarcodeValue();
					if (inputRef.current) inputRef.current.focus();
				}, 2000);
			} else {
				// On UI validation failure
				closeMesssageOverlay();
				setIsPartNumberProcessing(false);
				setPartFamilyScannedData((prev) => ({
					...prev,
					isPartNumberScanningDone: false,
					isErrorInScanningPartNumber: true,
				}));
				showMessageOverlay({
					contextText:
						PART_VALIDATION_ERROR.ERROR_CONTEXT_TEXT + 'Scanning Part Number',
					info: 'The Part number mismatched.',
					error: true,
				});
				resetBarcodeValue();
			}
		}, 1000);
	};

	const onPartNumberSubmit = (scannedValue, resetBarcodeValue) => {
		const closeMesssageOverlay = showMessageOverlay({
			contextText: 'Scanning Part Number.',
			loading: true,
		});

		// Always pick the next pending row sequentially
		const selectedPart = displayedRows.find(
			(row) => row.status !== 'Validated' && row.status !== 'Skipped',
		);
		if (!selectedPart) {
			closeMesssageOverlay();
			showMessageOverlay({ contextText: 'All parts validated', error: true });
			resetBarcodeValue();
			return;
		}

		// For Logic 3: genealogyRequired = false && partNumberScanningRequired = true
		// Send scanned part number and serial number as null
		validatePart(
			partValidation.sequenceNumber,
			{
				familyId: selectedPart.familyId,
				partNumber: selectedPart.partNumber,
				scannedPartNumber: scannedValue,
				scannedSerialNumber: '',
			},
			(data) => {
				const { scanJobDetails } = data;
				closeMesssageOverlay();
				setSuccessMessage('Part Number Matched');
				setPartFamilyScannedData(INTIAL_PART_FAMILY_SCAN_DATA);

				// Update the partValidation state with new data
				updatePartValidation(data);

				setTimeout(() => {
					setSuccessMessage('');
					resetBarcodeValue();
					redirectToNextScreen(scanJobDetails);
				}, 3000);
			},
			(error) => {
				closeMesssageOverlay();
				setSkippedPartNumber(scannedValue);
				showMessageOverlay({
					contextText:
						PART_VALIDATION_ERROR.ERROR_CONTEXT_TEXT + 'Scanning Part Number',
					info: error?.response?.data?.message,
					error: true,
				});
				resetBarcodeValue();
			},
		);
	};

	const onSerialNumberSubmit = (scannedValue, resetBarcodeValue) => {
		const closeMesssageOverlay = showMessageOverlay({
			contextText: 'Scanning Serial Number.',
			loading: true,
		});

		// Find the selected part to validate based on selectedPvRows
		const selectedPart = displayedRows.find(
			(row) => row.status !== 'Validated' && row.status !== 'Skipped',
		);
		if (!selectedPart) {
			closeMesssageOverlay();
			showMessageOverlay({ contextText: 'All parts validated', error: true });
			resetBarcodeValue();
			return;
		}

		setPartFamilyScannedData((prev) => ({
			...prev,
			scannedSerialNumber: scannedValue,
		}));

		// For Logic 1 & 2: Send scanned serial number and part number based on logic
		const { genealogyRequired, partNumberScanningRequired } = selectedPart;
		const scannedPartNumber =
			genealogyRequired && !partNumberScanningRequired
				? ''
				: partFamilyScannedData.scannedPartNumber; // Use the previously scanned part number for Logic 2

		validatePart(
			partValidation.sequenceNumber,
			{
				familyId: selectedPart.familyId,
				partNumber: selectedPart.partNumber,
				scannedPartNumber: scannedPartNumber,
				scannedSerialNumber: scannedValue,
			},
			(data) => {
				const { scanJobDetails } = data;
				closeMesssageOverlay();
				setSuccessMessage('Serial Number Matched');
				setSkippedSerialNumber('');
				// Clear part number from local storage after successful full validation
				localStorage.removeItem('scannedPartNumber');

				setPartFamilyScannedData(INTIAL_PART_FAMILY_SCAN_DATA);
				setIsPartNumberProcessing(false);
				setTimeout(() => {
					setSuccessMessage('');
					resetBarcodeValue();
					redirectToNextScreen(scanJobDetails);
				}, 3000);
			},
			(error) => {
				closeMesssageOverlay();
				setSkippedSerialNumber(scannedValue);
				setPartFamilyScannedData((prev) => ({
					...prev,
					isSerialNumberScanningDone: false,
					isErrorInScanningSerialNumber: true,
				}));
				setIsPartNumberProcessing(false);
				showMessageOverlay({
					contextText:
						PART_VALIDATION_ERROR.ERROR_CONTEXT_TEXT + 'Scanning Serial Number',
					info: error?.response?.data?.message,
					error: true,
				});
				resetBarcodeValue();
			},
		);
	};

	const partSkipSuccessCallback = (data, closeSkipSerialNumberDialog) => {
		closeSkipSerialNumberDialog();
		toast.success('Part Skipped');

		localStorage.removeItem('scannedPartNumber');
		setPartFamilyScannedData(INTIAL_PART_FAMILY_SCAN_DATA);
		setIsPartNumberProcessing(false);

		const serialNumber = receivePart.serialNumber || currentLineItem.serialNumber;
		if (serialNumber) {
			getPartValidationDetailsForSerialNumber(
				(updatedData) => {
					updatePartValidation(updatedData);
				},
				(error) => {
					console.error('Error refreshing part validation details:', error);
				},
				serialNumber,
			);
		}

		setSelectedPvRows([]);
	};


	const partSkipErrorCallback = (error, closeSkipSerialNumberDialog) => {
		closeSkipSerialNumberDialog();
		setSkippedSerialNumber(partFamilyScannedData.scannedSerialNumber);
		showMessageOverlay({
			contextText:
				PART_VALIDATION_ERROR.ERROR_CONTEXT_TEXT + 'Skipping Part Family',
			info: error.response.data.message,
			error: true,
		});
	};

	const renderInputFields = () => {
		// Get the first selected part to determine scanning requirements
		const selectedPart = displayedRows.find(
			(row) => row.id === selectedPvRows[0],
		);

		if (!selectedPart) {
			// Show default scanning interface when no part is selected
			const barcodeIconHeight = getResponsiveValue({
				laptop: 35,
				fhd: 40,
				qhd: 50,
				'4k': 80,
				'4k_plus': 100,
			});

			const barcodeIconWidth = getResponsiveValue({
				laptop: 75,
				fhd: 130,
				qhd: 160,
				'4k': 180,
				'4k_plus': 220,
			});

			const inputMinWidth = getResponsiveValue({
				laptop: '400px',
				fhd: '500px',
				qhd: '600px',
				'4k': '700px',
				'4k_plus': '800px',
			});

			return (
				<Box
					className={clsx(styles.scanningInputContainer, {
						[styles.assemblyLine]: isAssemblyLine,
					})}
				>
					<Box
						className={styles.barcodeIconContainer}
						sx={{
							height: barcodeIconHeight,
							width: barcodeIconWidth,
						}}
					>
						<img
							src={darkBarcode}
							alt="barcode"
							className={styles.barcodeIcon}
						/>
					</Box>

					<Box
						className={styles.inputContainer}
						sx={{ minWidth: inputMinWidth }}
					>
						<ScanOrEnterBarcodeForm
							enableAutoEnter={true}
							inputRef={inputRef}
							onSubmit={onPartNumberSubmit} // Default to part number scanning
							placeholder="Part Number Scan"
						/>
					</Box>
				</Box>
			);
		}

		const { genealogyRequired, partNumberScanningRequired } = selectedPart;

		// Determine what to scan based on the three logic conditions
		let shouldScanPartNumber = false;
		let shouldScanSerialNumber = false;
		let scanLabel = '';
		let onSubmitHandler = null;
		let isInputDisabled = false;

		if (genealogyRequired && !partNumberScanningRequired) {
			// Logic 1: Only scan serial number
			shouldScanSerialNumber = true;
			scanLabel = 'SCAN SERIAL NUMBER';
			onSubmitHandler = onSerialNumberSubmit;
		} else if (partNumberScanningRequired && genealogyRequired) {
			// Logic 2: Scan part number first, then serial number
			if (!partFamilyScannedData.isPartNumberScanningDone) {
				// First scan: Part Number
				shouldScanPartNumber = true;
				scanLabel = 'SCAN PART NUMBER';
				onSubmitHandler = onPartSubmitGenelogyAndPartValidation;
				// Disable input while part number is being processed
				isInputDisabled = isPartNumberProcessing;
			} else {
				// Second scan: Serial Number (after part number is validated)
				shouldScanSerialNumber = true;
				scanLabel = 'SCAN SERIAL NUMBER';
				onSubmitHandler = onSerialNumberSubmit;
			}
		} else if (!genealogyRequired && partNumberScanningRequired) {
			// Logic 3: Only scan part number
			shouldScanPartNumber = true;
			scanLabel = 'SCAN PART NUMBER';
			onSubmitHandler = onPartNumberSubmit;
		} else if (!genealogyRequired && !partNumberScanningRequired) {
			// Backend can occasionally send both flags false while operator still needs
			// to complete serial scan for the selected part in production.
			shouldScanSerialNumber = true;
			scanLabel = 'SCAN SERIAL NUMBER';
			onSubmitHandler = onSerialNumberSubmit;
		}

		// No scan step is needed for this part state.
		// Avoid rendering barcode form with a null submit handler.
		if (!shouldScanPartNumber && !shouldScanSerialNumber) {
			return null;
		}

		// Calculate responsive dimensions
		const barcodeIconHeight = getResponsiveValue({
			laptop: 35,
			fhd: 40,
			qhd: 50,
			'4k': 80,
			'4k_plus': 100,
		});

		const barcodeIconWidth = getResponsiveValue({
			laptop: 75,
			fhd: 130,
			qhd: 160,
			'4k': 180,
			'4k_plus': 220,
		});

		const inputMinWidth = getResponsiveValue({
			laptop: '400px',
			fhd: '500px',
			qhd: '600px',
			'4k': '700px',
			'4k_plus': '800px',
		});

		return (
			<Box
				className={clsx(styles.scanningInputContainer, {
					[styles.assemblyLine]: isAssemblyLine,
				})}
			>
				<Box
					className={styles.barcodeIconContainer}
					sx={{
						height: barcodeIconHeight,
						width: barcodeIconWidth,
					}}
				>
					<img src={darkBarcode} alt="barcode" className={styles.barcodeIcon} />
				</Box>

				<Box className={styles.inputContainer} sx={{ minWidth: inputMinWidth }}>
					<ScanOrEnterBarcodeForm
						enableAutoEnter={true}
						inputRef={inputRef}
						onSubmit={onSubmitHandler}
						placeholder={
							shouldScanPartNumber ? 'Part Number Scan' : 'Serial Number Scan'
						}
						inputProps={{
							disabled: isInputDisabled || selectedPvRows.length === 0,
						}}
					/>
				</Box>
			</Box>
		);
	};

	useEffect(() => {
		if (!isPopupOpen && inputRef.current) inputRef.current.focus();
	}, [isPopupOpen]);

	useEffect(() => {
		if (tableRows && tableRows.length > 0) {
			const isEveryUnitProcessed = tableRows.every(
				(item) => item.scannedSerialNumber || item.scannedPartNumber || item.skipReason || (item.scanJobResults && item.scanJobResults.length >= item.quantity)
			);
			setAllScanned(isEveryUnitProcessed);
		} else if (scanJobDetails && scanJobDetails.length > 0) {
			const allPartsScanned = scanJobDetails.every((item) => {
				const isFullyScanned = item?.quantity === item?.scanJobResults?.length;
				const isSkipped = !!item?.skipReason;
				return isFullyScanned || isSkipped;
			});
			setAllScanned(allPartsScanned);
		}
	}, [tableRows, scanJobDetails]);


	// Auto-trigger mark complete after 2 seconds when all parts are validated
	// COMMENTED OUT: API should only be called when user clicks Mark Complete button
	// useEffect(() => {
	// 	if (allScanned && scanJobDetails && scanJobDetails.length > 0) {
	// 		const timer = setTimeout(() => {
	// 			markComplete(
	// 				() => {
	// 					updatePartValidation({});
	// 					redirect(() => handleNext());
	// 				},
	// 				(error) => {
	// 					showMessageOverlay({
	// 						contextText: ERROR_MESSAGE.MARK_COMPLETE_ERROR_MESSAGE,
	// 						info: error?.response?.data?.message,
	// 						error: true,
	// 					});
	// 				},
	// 				partValidation.sequenceNumber,
	// 			);
	// 		}, 2000); // 2 seconds delay

	// 		return () => {
	// 			clearTimeout(timer);
	// 		};
	// 	}
	// }, [
	// 	allScanned,
	// 	scanJobDetails,
	// 	markComplete,
	// 	updatePartValidation,
	// 	redirect,
	// 	handleNext,
	// 	partValidation.sequenceNumber,
	// 	showMessageOverlay,
	// ]);

	// Update tableRows when partValidation changes (for manual mode)
	useEffect(() => {
		if (partValidation?.scanJobDetails && partValidation?.sequenceNumber) {
			const rowsData = getPartFamiliesToValidate(
				partValidation.scanJobDetails,
				partValidation.sequenceNumber,
			);
			setTableRows(rowsData);
		}
	}, [partValidation]);

	useEffect(() => {
		const currentSerialNumber = receivePart.serialNumber || currentLineItem.serialNumber;

		const isScanAttributeOnly = operations?.allowedOperations?.includes('SCAN_ATTRIBUTE')

		if (isScanAttributeOnly) return;

		const needsFetch = !partValidation?.scanJobDetails ||
			partValidation.scanJobDetails.length === 0 ||
			(partValidation.serialNumber && partValidation.serialNumber !== currentSerialNumber);

		if (
			partValidation &&
			partValidation.scanJobDetails &&
			partValidation.scanJobDetails.length > 0 &&
			!needsFetch
		) {
			const rowsData = getPartFamiliesToValidate(
				partValidation.scanJobDetails,
				partValidation.sequenceNumber,
			);
			setTableRows(rowsData);

			if (!partValidation.scanJobDetails.length) {
				setNoPartFamilyConfigured(true);
			} else {
				const nonScannedPartFamilyIndex = partValidation.scanJobDetails.findIndex(
					(part) => part.scanJobResults.length !== part.quantity,
				);
				if (nonScannedPartFamilyIndex === -1)
					setCurrentPartNumber(partValidation.scanJobDetails.length - 1);
				else setCurrentPartNumber(nonScannedPartFamilyIndex);
			}
		} else if (currentSerialNumber) {
			const isScanAttributeOnly = operations?.allowedOperations?.includes('SCAN_ATTRIBUTE') &&
				!operations?.allowedOperations?.includes('PART_VALIDATION');
			if (isScanAttributeOnly) return;
			getPartValidationDetailsForSerialNumber(
				(data) => {
					updatePartValidation(data);
					if (data.scanJobDetails && data.scanJobDetails.length > 0) {
						const rowsData = getPartFamiliesToValidate(
							data.scanJobDetails,
							data.sequenceNumber,
						);
						setTableRows(rowsData);
					}
					if (!data.scanJobDetails.length) {
						setNoPartFamilyConfigured(true);
					} else {
						const nonScannedPartFamilyIndex = data.scanJobDetails.findIndex(
							(part) => part.scanJobResults.length !== part.quantity,
						);
						if (nonScannedPartFamilyIndex === -1)
							setCurrentPartNumber(data.scanJobDetails.length - 1);
						else setCurrentPartNumber(nonScannedPartFamilyIndex);
					}
				},
				(error) => {
					updatePartValidation({});
					showMessageOverlay({
						contextText: PART_VALIDATION_ERROR.ERROR_CONTEXT_TEXT + 'Part Validation',
						info: error?.response?.data?.message,
						error: true,
					});
				},
				currentSerialNumber,
			);
		}
	}, [receivePart.serialNumber, currentLineItem.serialNumber, partValidation?.serialNumber]);
	const redirectToHomeScreen = () =>
		redirect(null, {
			operation: OPERATIONS.RECEIVE_PART,
			redirectUrl: REDIRECT_URLS[OPERATIONS.RECEIVE_PART],
		});

	return (
		<>
			{/* --- Current KSPEC Header Table --- */}
			<Box sx={{ pr: 2 }}>
				<StyledTable
					title="Current KSPEC"
					columns={PV_DEFAULT_COLUMNS}
					rows={pvData}
					forceHeight={isAssemblyLine ? 120 : 60}
					elevated
					filterMenu={false}
					showFilter={false}
					showColumns={false}
				/>
			</Box>

			{/* --- Conditional Content --- */}
			{(() => {
				const hasPartFamilies = scanJobDetails && scanJobDetails.length > 0;
				const shouldShowCompletion =
					(noPartFamilyConfigured && hasPartFamilies === false) ||
					(hasPartFamilies && allScanned);
				return shouldShowCompletion;
			})() ? (

				<>
					{/* Validation Complete - Still show table */}
					<Box sx={{ paddingX: 2, paddingTop: 1 }}>
						<Grid
							sx={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								width: '100%',
							}}
						>
							{/* <TableActionsBar
								leftContent={
									<ProgressHeader
										current={
											scanJobDetails?.reduce((total, part) => {
												const scanJobResults = part.scanJobResults || [];
												const validatedCount = scanJobResults.filter(
													(result) => !result.skipReason,
												).length;
												const skippedCount = scanJobResults.filter(
													(result) => result.skipReason,
												).length;
												const processedCount = validatedCount + skippedCount;
												return total + processedCount;
											}, 0) || 0
										}
										total={
											scanJobDetails?.reduce(
												(total, part) => total + (part.quantity || 0),
												0,
											) || 0
										}
										label={'Part Validation'}
									/>
								}
								onViewReportClick={openReportModal}
								showColumns
								showFilter
								showViewReport
								columns={TEXT_COLUMNS}
								rows={scanJobDetails}
								// onFilter={(filteredRows) => setDisplayedRows(filteredRows)}
								// onColumnChange={(columns) => setTextColumns(columns)}
								defaultColumns={[...TEXT_COLUMNS]}
							/> */}
						</Grid>

						<Grid
							container
							alignItems="flex-start"
							justifyContent="flex-start"
							sx={{
								marginBottom: 2,
								height: {
									xs: 'auto',
									md: '40vh',
									xl: '35vh',
									'4k': '30vh',
								},
							}}
						>
							<Grid
								item
								sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}
							>
								<StyledTable
									columns={TEXT_COLUMNS}
									rows={displayedRowsMapCheckbox}
									showCheckBox={true}
									elevated
									sx={{
										flex: 1,
										height: '100%',
									}}
									onHandleRowClick={resetState}
								/>
							</Grid>
						</Grid>
					</Box>

					{/* --- Success Message / Completion Section --- */}
					<Box
						sx={{
							...classNames.tableContentContainer,
							marginTop: {
								xs: 2,
								md: 3,
								xl: 4,
								'4k': 6,
							},
							paddingBottom: 4,
						}}
					>
						<Grid container paddingX={3} paddingY={5} flex={1} alignItems="end">
							<Grid
								item
								container
								alignItems="center"
								justifyContent="space-between"
								columnSpacing={2}
							>
								<Grid item>
									<Box className={styles.successMessageText}>
										<CheckIcon
											color="primary"
											className={styles.successIcon}
											sx={{
												fontSize: getResponsiveValue({
													laptop: 24,
													fhd: 28,
													qhd: 32,
													'4k': 40,
													'4k_plus': 48,
												}),
											}}
										/>
										<Typography
											variant="h4"
											color="primary"
											fontWeight={500}
											sx={{
												fontSize: getResponsiveValue({
													laptop: '20px',
													fhd: '24px',
													qhd: '28px',
													'4k': '32px',
													'4k_plus': '36px',
												}),
											}}
										>
											Part Validation Completed
										</Typography>
									</Box>
								</Grid>

								<Grid item display="flex" gap={2}>
									{!isEmbedded ? (
										<MarkComplete
											onMarkComplete={() => {
												stopSecondApiPolling();
												setSecondApiStop(false);
												markComplete(
													() => {
														updatePartValidation({});
														redirect(() => handleNext());
													},
													(error) => {
														showMessageOverlay({
															contextText: ERROR_MESSAGE.MARK_COMPLETE_ERROR_MESSAGE,
															info: error?.response?.data?.message,
															error: true,
														});
													},
													partValidation.sequenceNumber,
												);
											}}
											onNextOperation={() => {
												stopSecondApiPolling();
												setSecondApiStop(false);
												redirect(() => handleNext());
											}}
										/>

									) : (
										<MarkComplete
											onMarkComplete={() => {
												if (onCompletionOverride) {
													setSecondApiStop(false);
													stopSecondApiPolling();
													onCompletionOverride();
												} else {
													markComplete(
														() => {
															setSecondApiStop(false);
															stopSecondApiPolling();
															updatePartValidation({});
															redirect(() => handleNext());
														},
														(error) => {
															showMessageOverlay({
																contextText: ERROR_MESSAGE.MARK_COMPLETE_ERROR_MESSAGE,
																info: error?.response?.data?.message,
																error: true,
															});
														},
														partValidation.sequenceNumber,
													);
												}
											}}
											onNextOperation={() => {
												setSecondApiStop(false)
												stopSecondApiPolling();
												redirect(() => handleNext());
											}}
										/>

									)}
								</Grid>
							</Grid>
						</Grid>
					</Box>
				</>
			) : (
				/* --- ACTIVE MODE SECTION --- */
				<Box sx={classNames.tableContentContainer}>
					<Box sx={{ paddingX: 3, paddingTop: 1 }}>
						<Grid
							sx={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								width: '100%',
							}}
						>
							<TableActionsBar
								leftContent={null}
								showDefactive={
									!!(
										receivePart.serialNumber ||
										partValidation.serialNumber
									)
								}
								onDefectClick={() => setIsDefectModalOpen(true)}
								onViewReportClick={openReportModal}
								showColumns
								showFilter
								showViewReport
								columns={scanColumns}
								defaultColumns={[...TEXT_COLUMNS]}
								rows={scanJobDetails}
								onFilterChange={(filters) => setScanFilters(filters)}
								onColumnChange={(updatedColumns) =>
									setScanColumns(updatedColumns)
								}
							/>

						</Grid>
						<Grid container spacing={4} justifyContent="space-between" alignItems='center'>
							<Grid item sx={{ mb: '1%' }}>
								<ProgressHeader
									current={partValidationCurrent}
									total={partValidationTotal}
									label="Part Validation"
								/>
							</Grid>

							{hasMachineOperation && (
								<Grid item sx={{ mr: '16%', mb: '1%' }}>
									<ProgressHeader
										current={machineOperationCurrent}
										total={machineOperationTotal}
										label="Machine Operation"
									/>
								</Grid>
							)}
						</Grid>

						{/* <Grid
							container
							alignItems="flex-start"
							justifyContent="flex-start"
							sx={{
								marginBottom: 1,
								height: {
									xs: '40vh',
									md: '40vh',
									xl: '35vh',
									'4k': '30vh',
								},
							}}
						>
							<Grid
								item
								sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}
							>
								<StyledTable
									columns={filteredColoumn}
									rows={displayedRowsMapCheckbox}
									showCheckBox={true}
									elevated
									forceHeight={tableHeight}
									selectedRows={selectedPvRows}
									onSelectionChange={handleSelectionChange}
									paginated
									sx={{
										flex: 1,
										height: '100%',
									}}
									setSkippart={setSkippart}
									onHandleRowClick={resetState}
								/>
							</Grid>
						</Grid> */}

						<Grid
							container
							spacing={2}
							sx={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'stretch',
								height: {
									xs: '40vh',
									md: '40vh',
									xl: '35vh',
									'4k': '30vh',
								},
								minHeight: 330,
							}}
						>
							<Grid
								item
								xs={hasMachineOperation ? 8 : false}
								sx={{
									flex: 1,
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<StyledTable
									columns={scanColumns}
									rows={displayedRowsMapCheckbox}
									filters={scanFilters}
									showCheckBox
									elevated
									selectedRows={selectedPvRows}
									onSelectionChange={(selectedIds, row) =>
										handleSelectionChange(selectedIds, row)
									}
									onHandleRowClick={resetState}
									sx={{
										flex: 1,
										height: '100%',
									}}
								/>
							</Grid>

							{/* --- Torque Table --- */}
							{hasMachineOperation && (
								<Grid
									item
									xs={4}
									sx={{
										display: 'flex',
										flexDirection: 'column',
									}}
								>
									<StyledTable
										columns={torqueTableHeader}
										rows={torqueTableRows}
										selectall={false}
										elevated
										paginated={true}
										showCheckBox={true}          // 👈 important
										selectedRows={selectedTorqueRows}
										onSelectionChange={handleTorqueSelectionChange}
										sx={{
											flex: 1,
											height: '100%',
											tableColors: {
												headerText: '#F8F8F8',
												headerBackground:
													themeMode === DARK_MODE ? '#0f172a' : '#0F107B',
											},
										}}
									/>
								</Grid>
							)}
						</Grid>
					</Box>

					{/* --- Manual vs Non-manual Mode --- */}
					{modeType === 'Manual Mode' ? (
						<BasicTable
							listId="genealogy-page"
							rows={tableRows || []}
							columns={[...PVnG_DEFAULT_COLUMNS]}
							defaultColumns={[...PVnG_DEFAULT_COLUMNS]}
							showCheckBox
							tableStyles={{
								paper: classNames.paper,
								tableContainer: classNames.tableContentContainer,
							}}
						>
							{(selectedRows) => (
								<>
									<Divider />
									<Grid
										container
										item
										justifyContent="space-between"
										alignItems="bottom"
										paddingX={3}
										paddingBottom={2}
									>
										<Grid xs container>
											<UpdatePartValidationGenealogy
												themeMode={themeMode}
												selectedRows={selectedRows}
												setAllScanned={setAllScanned}
												validatePart={validatePart}
												tableRows={tableRows}
												setTableRows={setTableRows}
												partValidation={partValidation}
												partSkipSuccessCallback={partSkipSuccessCallback}
												partSkipErrorCallback={partSkipErrorCallback}
											/>
										</Grid>
									</Grid>
								</>
							)}
						</BasicTable>
					) : (
						/* --- Bottom Action Section --- */
						<Grid
							container
							paddingX={2}
							paddingY={4}
							justifyContent="space-between"
							alignItems="flex-start"
							sx={{
								mt: {
									xs: 6,
									md: 12,
									xl: 18,
									'4k': 20,
								},
								pr: {
									xs: 2,
									md: 2,
									xl: 24,
									'4k': 24,
								},
							}}
						>
							<Grid item>
								{/* {!successMessage ? ( */}

								{!skippedTorqueRow ? <SkipPart
									skippart={skippart}
									skippedSerialNumber={skippedSerialNumber}
									skippedPartNumber={skippedPartNumber}
									successCallback={partSkipSuccessCallback}
									errorCallback={partSkipErrorCallback}
									selectedRowData={
										selectedPvRows.length > 0
											? displayedRows.find(
												(row) => row.id === selectedPvRows[0],
											)
											: null
									}
									setSecondApiStop={setSecondApiStop}
									disableBtn={selectedPvRows.length === 0}
									hoverMessage={
										selectedPvRows.length === 0
											? 'Please select a part to skip'
											: ''
									}
								/> :

									<SkipPart
										skippedSerialNumber={skippedTorqueRow?.parameterKey || skippedTorqueRow?.key || skippedTorqueRow?.description || ''}
										skippedPartNumber={skippedTorqueRow?.parameterName || skippedTorqueRow?.value || ''}
										skipModalTitle="Skip Machine Operation"
										successCallback={(data) => {
											toast.success(selectedTorqueRows.length > 1 ? 'Torque Rows Skipped' : 'Torque Row Skipped');
											setSkippedTorqueRow(null); // close SkipPart after success
											// Clear selection
											setSelectedTorqueRows([]);
											// Refresh torque table
											const sn = partValidation.serialNumber || receivePart.serialNumber || currentLineItem?.serialNumber;
											if (sn) callSecondApi(sn);
										}}
										errorCallback={(error) => {
											toast.error('Error skipping torque row(s)');
										}}
										selectedRowData={skippedTorqueRow}
										selectedTorqueRows={selectedTorqueRows}
										allTorqueRows={torqueTableRows}
										disableBtn={selectedTorqueRows.length === 0}
										hoverMessage={selectedTorqueRows.length === 0 ? 'Select Torque row(s) to skip' : ''}
										setSecondApiStop={setSecondApiStop}
									/>


								}
								{/* ) : (
									<Grid container alignItems="center">
										<CheckIcon color="primary" sx={{ fontSize: 34 }} />
										<Typography
											variant="h4"
											color="primary"
											fontWeight={400}
							 			paddingLeft={1}
										>
											{successMessage}
										</Typography>
									</Grid>
							 )} */}
							</Grid>

							{/* Right-aligned input fields */}
							<Grid
								item
								sx={{
									marginLeft: 'auto',
									flexShrink: 0,
									maxWidth: {
										xs: '100%',
										sm: '80%',
										md: '60%',
										xl: '40%',
										'4k': '30%',
									},
									display: 'flex',
									justifyContent: 'flex-end',
								}}
							>
								{renderInputFields()}
							</Grid>
						</Grid>
					)}
				</Box>
			)}

			{/* --- Modals --- */}
			<AllPartsModal
				open={isDetailsModalOpen}
				handleClose={closeDetailsModal}
				rows={[partValidation]}
				columns={[...PV_DEFAULT_COLUMNS]}
				defaultColumns={[...PV_DEFAULT_COLUMNS]}
				title="Current KSPEC"
				subtitle="Key Attributes"
				tableStyles={{ paper: classNames.paper }}
				scannableParts={scanJobDetails}
			/>
			<RescanModal
				open={isReportModalOpen}
				handleClose={closeReportModal}
				rows={[partValidation]}
				scannableParts={scanJobDetails}
				showTorqueTable={hasMachineOperation}
				torqueData={torqueTableRows}
			/>
			<DefectModal
				open={isDefectModalOpen}
				handleClose={() => setIsDefectModalOpen(false)}
				partDetailsRow={pvData}
				partDetails={{
					serialNumber:
						receivePart.serialNumber ||
						partValidation.serialNumber,
					sequenceNumber: partValidation.sequenceNumber,
				}}
			/>
		</>
	);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(PartValidationStages);
